export const SUBSTITUTION_STRATEGIES = [
  {
    id: 'color_sequence',
    name: 'Color Sequence',
    description: 'Organize substitutions by color-coded packages with rotation sequence'
  },
  {
    id: 'drive_based',
    name: 'Drive Based',
    description: 'Alternate players based on offensive/defensive drives'
  },
  {
    id: 'package_based',
    name: 'Package Based', 
    description: 'Simple rotation using Alpha and Bravo packages - each player in one package only'
  }
  // {
  //   id: 'snap_based',
  //   name: 'Snap Based',
  //   description: 'Rotate players by quarters with MPR play recommendations per quarter'
  // }
];
